import React, { Component } from 'react';
import KickImage from 'Reuseables/KickImage';
import { Link } from 'react-router-dom';
import lineIcon from '../../images/line-icon.png';
import {
    Modal,
    ModalHeader,
    ModalBody,
    Container } from 'reactstrap';
export default class ModalLineInfo extends Component{
    render(){
        return(
            <Modal isOpen={this.props.isOpen} toggle={this.props.onToggle} className="kick-modal">
                <ModalHeader toggle={this.props.onToggle}>Add Whatsapp Kami</ModalHeader>
                <ModalBody>
                    <Container className="text-center">
                        <KickImage alt="Line icon" src={lineIcon} width={150}/>
                        {/* <h3>@kickavenue</h3> */}
                        <p>
                            Jika ada pertanyaan lainnya yang tidak terdapat pada laman
                            {' '}<Link to="/helps/faq">FAQ</Link>, silahkan tanya apa saja melalui account whatsapp kita.</p>
                    </Container>
                </ModalBody>
            </Modal>
        )
    }
}